export default __webpack_public_path__ + "static/media/bg9.cf9a123e.jpg";